import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    offers: `${APP_CONFIG.care_cluster}/tariffs/`,
    type: 'fiber',
  },
}
